import React from 'react';
import { Modal } from 'react-bootstrap';

function ModalPsikologDetail({ show, onHide, psikolog }) {
  if (!psikolog) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Body className="psikolog-detail-modal">
        <div className="modal-header border-0">
          <button type="button" className="btn-close" onClick={onHide}></button>
        </div>

        <div className="modal-body">
          <div className="row">
            {/* FOTO */}
            <div className="col-md-3 text-center">
              <img
                src={psikolog.foto}
                alt={psikolog.name}
                className="psikolog-detail-photo mb-3"
              />
            </div>

            {/* KONTEN */}
            <div className="col-md-9">
              <div className="psikolog-detail-sticky">
                <div className="psikolog-detail-name">
                  {psikolog.name}
                </div>
                <div className="psikolog-detail-title">
                  {psikolog.bahasa}
                </div>
              </div>

              <div className="psikolog-detail-scroll">
                <div className="psikolog-detail-section">
                  Profil Psikolog
                </div>

                <div
                  className="psikolog-detail-list"
                  dangerouslySetInnerHTML={{
                    __html: psikolog.description || '<p>-</p>',
                  }}
                />

                {/* ===== FALLBACK STATIC CONTENT (TETAP ADA) ===== */}
                {/* <div className="psikolog-detail-section">Asosiasi Profesi</div>
                <ul className="psikolog-detail-list">
                  <li>HIMPSI – Himpunan Psikologi Indonesia</li>
                </ul> */}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ModalPsikologDetail;
